import { css } from 'lit';

export const baseStyles = css`
  :host([part='retail']) {
    font-family: var(
      --fg-font-family--serif,
      var(--fg-fallback-font-family--serif)
    );
    font-size: 0.875rem;
    color: var(--fg-gray--800, var(--fg-fallback-gray--800));
    line-height: 1.143;
  }

  :host([part='retail']) h1,
  :host([part='retail']) h2,
  :host([part='retail']) h3,
  :host([part='retail']) h4,
  :host([part='retail']) h5 {
    font-family: var(
      --fg-font-family--brand,
      var(--fg-fallback-font-family--brand)
    );
    font-weight: 700;
    margin: 0;
  }

  :host([part='wholesale']) {
    font-family: var(
      --fg-font-family--serif,
      var(--fg-fallback-font-family--serif)
    );
    font-size: 1rem;
    line-height: 160%;
    color: var(--fg-gray--800, var(--fg-fallback-gray--800));
  }

  :host([part='wholesale']) h1,
  :host([part='wholesale']) h2,
  :host([part='wholesale']) h3,
  :host([part='wholesale']) h4,
  :host([part='wholesale']) h5 {
    font-family: var(--fg-font-family--brand);
    line-height: 140%;
    color: var(--fg-primary, var(--fg-fallback-primary));
    margin: 0;
  }

  /* Default css will fall back to retail styling */
  :host {
    font-family: var(
      --fg-font-family--serif,
      var(--fg-fallback-font-family--serif)
    );
    font-size: 0.875rem;
    color: var(--fg-gray--800, var(--fg-fallback-gray--800));
    line-height: 1.143;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-family: var(
      --fg-font-family--brand,
      var(--fg-fallback-font-family--brand)
    );
    font-weight: 700;
    margin: 0;
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  p {
    margin: 0;
  }

  ul,
  li {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  a {
    color: var(--fg-primary, var(--fg-fallback-primary));
    text-decoration: underline;
  }

  img {
    height: auto;
    display: block;
  }

  button {
    font: inherit;
    color: inherit;
    text-align: left;
    background: none;
    border: none;
    outline: inherit;
    cursor: pointer;
    padding: 0;
  }

  table {
    background: none;
    border: none;
    border-spacing: 0;
    padding: 0;
    margin: 0;
  }

  .visually-hidden {
    border: 0;
    clip: rect(0, 0, 0, 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
`;
